exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n\r\n.bottomed-button\r\n{\r\n    position: absolute;\r\n    bottom: 0;\r\n}\r\n.invoice-details-icon\r\n{\r\n    font-size: 18px;\r\n    color: green;\r\n    cursor: pointer;\r\n}\r\n.lines-icon\r\n{\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n}\r\n.details-link\r\n{\r\n    border: 1px solid green;\r\n    border-radius: 3px;\r\n    padding: 2px 7px;\r\n    float: left;\r\n    cursor: pointer;\r\n    color: green!important;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/report/report-customer-invoice/report-customer-invoice.component.css
// module id = ../../../../../src/app/report/report-customer-invoice/report-customer-invoice.component.css
// module chunks = main